// src/pages/LoginPage.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { USERS } from '../users';
import { setLSWithExpiry } from '../helpers';
import './../../src/App.css'

function LoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();
    const user = USERS.find(u => u.username === username && u.password === password);
    if (user) {
      setLSWithExpiry('authKey', username);
      navigate('/');
    } else {
      setError('Invalid credentials');
    }
  };

  return (
    <div className="container mt-5">
      <div class="row">
        <div class="col-sm-3"></div>
        <div class="col-sm-6 card p-5">
          <h2>Login</h2>
          <form onSubmit={handleLogin}>
            <input className="form-control my-2" value={username} onChange={e => setUsername(e.target.value)} placeholder="Username" required />
            <input className="form-control my-2" value={password} onChange={e => setPassword(e.target.value)} placeholder="Password" type="password" required />
            <button className="btn login-btn" type="submit">Login</button>
            {error && <p className="text-danger mt-2">{error}</p>}
          </form>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
